export const hashString = (str: string) =>
  str.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

export const getConsistentColor = (name: string) => {
  const colors = [
    '#FF5733',
    '#33FF57',
    '#3357FF',
    '#FF33A6',
    '#FFD133',
    '#8E44AD',
    '#1ABC9C',
    '#E67E22',
    '#2ECC71',
    '#3498DB',
  ];
  return colors[hashString(name) % colors.length];
};

export const getInitial = (name: string) => name.charAt(0).toUpperCase();
